(function() {
    'use strict';
    angular
        .module('getwellApp')
        .factory('Booking', Booking);

    Booking.$inject = ['$resource', 'DateUtils'];

    function Booking ($resource, DateUtils) {
        var resourceUrl =  'api/bookings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.bookingTime = DateUtils.convertDateTimeFromServer(data.bookingTime);
                        data.appointmentStartTime = DateUtils.convertDateTimeFromServer(data.appointmentStartTime);
                        data.appointmentEndTime = DateUtils.convertDateTimeFromServer(data.appointmentEndTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
